export default __webpack_public_path__ + "static/media/Wallet.b5a49c79.svg";